import { CatButton } from 'blocks-nextjs/blocks-react/components/Button';
import { useTranslations } from 'next-intl';

type ViewResultProps = {
  count: number;
  onClick?: (e: MouseEvent) => void;
  fullWidth?: boolean;
};

export const ViewResultsButton = ({
  count,
  onClick,
  fullWidth = false
}: ViewResultProps) => {
  const t = useTranslations();
  const viewResultText = t('VIEW_NUMBER_RESULTS', {
    0: count
  });

  return (
    <CatButton
      className="me-2"
      onClick={onClick}
      variant="primary"
      fullWidth={fullWidth}
    >
      {viewResultText}
    </CatButton>
  );
};
